<p-progressSpinner class="soc-manager-spinner spinner-in-front" *ngIf="spinner"></p-progressSpinner>
<div class="panel-wrapper">
  <button class="cyan-btn-large mb-4" (click)="uploadImagesDialog()">{{'VENUE.ADD_PHOTOS' | translate}} +</button>
  <button class="cyan-btn-large mb-4" (click)="openListAndEditHostsPopup()">{{'VENUE.ADD_HOSTS' | translate}} +</button>
  <button class="create-btn w-100" (click)="skip()">{{'Skip' | translate}}</button>
</div>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>

